import { API_NOTES_default } from '../../constants/endpoints'
import { controller } from '../../utilities/abortController'

export type MyNotesUser = {
    access_level: 0 | 1 | 2 | 4 | 5
    online: 0 | 1
    subject_id: number
    username: string
}
export type MyNotesUserList = Array<MyNotesUser>
export type MyNotesUserListResponse = {
    err?: number
    errmsg?: string
    id: string
    method: 'userNotepad/userList'
    responseVer: number
    result: MyNotesUserList
}

export type MyNotesResult = {
    last_login: string
    notes: string
    subject_id: number
    user_id: number
}
type MyNotesResponse = {
    err?: number
    errmsg?: string
    id: string
    method: string
    responseVer: number
    result: MyNotesResult
}

export async function fetchNotes(id: number) {
    const url = `${API_NOTES_default}/${id}`
    const response = await fetch(url, {
        credentials: 'include',
        signal: controller.signal,
    })
    const data = (await response.json()) as MyNotesResponse
    if (!data || data.err) {
        throw new Error(data.errmsg)
    }
    if (data.result === null) {
        return {
            notes: null,
            lastLogin: null,
        }
    }
    const { last_login, notes } = data.result
    return { lastLogin: last_login, notes }
}
